import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { GeoAnalyticsThemePreference } from "@/theme/tokens";

type ThemeState = {
  preference: GeoAnalyticsThemePreference;
  setPreference: (preference: GeoAnalyticsThemePreference) => void;
  toggleLightDark: () => void;
};

export const useThemePreferenceStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      preference: "system",
      setPreference: (preference) => set({ preference }),
      toggleLightDark: () => {
        const current = get().preference;
        set({ preference: current === "dark" ? "light" : "dark" });
      }
    }),
    {
      name: "geoanalytics.theme",
      partialize: (state) => ({ preference: state.preference })
    }
  )
);
